import styled from "styled-components";
import Mask from "react-input-mask";

interface IInputMask {
  err: boolean;
}

export const InputMask = styled(Mask)<IInputMask>`
  width: 100%;
  border: 1px solid ${({ err }: IInputMask) => (err ? "red" : "#d9d9d9")};
  background: #fff;
  border-radius: 10px;
  padding: 4px 11px;

  &:focus {
    border-color: #ffaf40;
    box-shadow: 0 0 0 2px rgba(243, 144, 22, 0.2);
    border-right-width: 1px;
    outline: 0;
  }
`;
